import { render, staticRenderFns } from "./summaries.vue?vue&type=template&id=f4c7523e&scoped=true"
import script from "./summaries.vue?vue&type=script&lang=js"
export * from "./summaries.vue?vue&type=script&lang=js"
import style0 from "./summaries.vue?vue&type=style&index=0&id=f4c7523e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c7523e",
  null
  
)

export default component.exports